import { echartVerStackedBar } from '../common';

export function echartAnellBarYear(vis, datos) {
  echartVerStackedBar(
    'chartAnellBar',
    'no_dataAnellBar',
    datos.resultset,
    'Bicicletes',
    'ANELL CICLISTA: HISTÒRIC ANUAL',
    '',
  );
}

export function echartAccesosBarYear(vis, datos) {
  echartVerStackedBar(
    'chartAccessosAnellBar',
    'no_dataAccessosAnellBar',
    datos.resultset,
    'Bicicletes',
    'ACCESSOS ANELL CICLISTA: HISTÒRIC ANUAL',
    '',
  );
}
